import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO component for managing document head metadata
 * @param {Object} props - Component props
 * @param {string} props.title - Page title
 * @param {string} props.description - Page description
 * @param {string} props.keywords - Page keywords
 * @param {string} props.ogImage - Open Graph image URL
 * @param {string} props.ogUrl - Open Graph URL
 * @param {string} props.canonicalUrl - Canonical URL
 */
const SEO = ({ 
  title = 'DomikTyumen - Аренда недвижимости в Тюмени',
  description = 'Аренда квартир, домов и коттеджей в Тюмени. Большой выбор недвижимости для комфортного проживания.',
  keywords = 'аренда, недвижимость, Тюмень, квартиры, дома, коттеджи, посуточно',
  ogImage = '/assets/og-image.jpg',
  ogUrl,
  canonicalUrl
}) => {
  // Get current URL if ogUrl not provided
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  const finalOgUrl = ogUrl || currentUrl;
  const finalCanonicalUrl = canonicalUrl || currentUrl;

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical link */}
      <link rel="canonical" href={finalCanonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={finalOgUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={finalOgUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
